import CustomFilterText from "../unit/CustomFilterText";

const getCounselorsListFilters = () => [
  <CustomFilterText key="id" label="Agency #" source="id" defaultValue="" />,
  <CustomFilterText
    key="sName"
    label="Organization"
    source="sName"
    defaultValue=""
  />,
  <CustomFilterText key="sCity" label="City" source="sCity" defaultValue="" />,
  <CustomFilterText key="sState" label="State" source="sState" defaultValue="" />,
  <CustomFilterText
    key="sAgencyAdminName"
    label="Agency Admin Name"
    source="sAgencyAdminName"
    defaultValue=""
  />,
  <CustomFilterText
    key="sAgencyAdminEmail"
    label="Agency Admin Email"
    source="sAgencyAdminEmail"
    defaultValue=""
  />,
];

export default getCounselorsListFilters;
